/* eslint-disable */

import React from "react";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Bar } from "react-chartjs-2";
import type { ChartData, ChartOptions } from "chart.js";

Chart.register(CategoryScale);
interface IProps {
  data: ChartData<"bar">;
  options: ChartOptions<"bar">;
}
const BarCharts = ({ data, options }: IProps) => {
  return (
    <div className="bar-chart">
      <Bar data={data} options={options} height={400} />
    </div>
  );
};

export default BarCharts;
